var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingBlade)?_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{attrs:{"src":_vm.loadingBladeUrl}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }